import { DocumentReference } from '@firebase/firestore-types';
import { Users } from '@just-in-types';
import { firestore } from '../firebase';

const devRef = firestore.collection('usersDev');
const prodRef = firestore.collection('users');

const getProdUsers = async (limit: number) => {
  const query = await prodRef.limit(limit).get();
  const users: Users.User[] = [];

  query.forEach(doc =>
    users.push({ ...doc.data(), userId: doc.id } as Users.User),
  );

  return users;
};

const writeDevUser = (user: Users.User) => devRef.doc(user.userId).set(user);

export default async (limit: number) => {
  const prodUsers = await getProdUsers(limit);
  const writes: Array<Promise<DocumentReference>> = [];

  console.log(prodUsers);

  prodUsers.forEach(prodUser => writeDevUser(prodUser));

  return Promise.all(writes);
};



// WEBPACK FOOTER //
// ./src/adminFunctions/copyUsersToDev.ts